



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderProductPrepare from './OrderProductPrepare.vue';
@Component({
  components: { AdminIframe, OrderProductPrepare },
})
export default class OrderProductPrepareIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/product-prepare' + '?' + queryString;
    return src;
  }
}
